<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="widget">
          <div class="widget-heading">
            <h2 class="textStyle">Gestion des inscriptions</h2>
          </div>
          <div class="widget-content">
            <ColumnBarChartComponent :datas="datas" :loading="loading" @click="chartClick" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { useMainStore } from "@/store/main/main";
import ColumnBarChartComponent from "@/components/charts/ColumnBarChartComponent.vue";
import { registrationManager } from "@/services/registration/registration-manager";

export default {
  components: { ColumnBarChartComponent },
  data() {
    return {
      datas: [],
      loading: false,
      categories: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.setAppLoading(false);
      this.loading = true;
      registrationManager.statistics().then((res) => {
        if (res && res.charts && Object.keys(res.charts).length && res.charts[0]) {
          this.datas = res.charts[0];
          this.categories = res.charts[0]?.custom?.categories;
          this.loading = false;
        }
      });
    },

    chartClick(index) {
      if (this.categories[index] && Object.keys(this.categories[index]).length) {
        this.$router.push({
          name: "RegistrationList",
          query: {
            registrationStep: [this.categories[index].id],
          },
        });
      }
    },

    ...mapActions(useMainStore, {
      setAppLoading: "setAppLoading",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
